$(function () {
    'use strict';

    function clipboardCopy (selector, attribute) {
        var $target = document.querySelector(selector);
        if (!$target) {
            return false;
        }
        var range = document.createRange();
        range.selectNode($target.firstChild);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');

        if (document.selection) {
            document.selection.empty();
        } else if (window.getSelection) {
            window.getSelection().removeAllRanges();
        }

        var message = 'クリップボードにコピーしました。'
        if (attribute) {
            message = attribute + 'を' + message
        }

        window.toastr.success(message, null, {timeOut: 3000})
        return false;
    }

    $.each($('.js-clipboard-copy'), function() {
        var selector = $(this).data('clipboard-copy-target');
        if (!selector) {
            selector = '#data-clipboard-copy';
        }
        var attribute = $(this).data('clipboard-copy-attribute')

        $(this).on('click', function() { clipboardCopy(selector, attribute)} );
    });
});
